import Link from "next/link";

export const BlogBackButton = () => (
  <Link href="/blog" className="flex w-screen justify-start px-5 md:px-11 lg:max-w-screen-xl">
    <div className="flex w-full justify-start">
      <button
        type="button"
        className="group flex h-10 w-10 items-center justify-center self-start rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition"
      >
        <svg
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
          className="h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700"
        >
          <path
            d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  </Link>
);
